
export default function StoreCard({store,handleClickStore}) {


 return (
    <div className="flex flex-col w-[260px] items-start justify-center relative" onClick={()=>handleClickStore(store?._id)}>
      <div className="flex flex-col h-[188px] items-center gap-2.5 px-2 py-4 relative self-stretch w-full bg-baiscwhite rounded-[8px_8px_0px_0px] !bg-no-repeat !bg-contain cursor-pointer select-none" style={{background: `#fff url(${store?.merchant?.logoImageURL}) no-repeat center center / cover`}}>
        
      </div>

      <div className="flex h-[70px] items-center gap-4 p-3 relative self-stretch w-full bg-grey-100 rounded-[0px_0px_8px_8px] border border-solid border-grey-100">
        <div className="inline-flex flex-col gap-1 relative flex-[0_0_auto] mt-[-3.00px] mb-[-3.00px]">
          <div className="relative w-fit mt-[-1.00px] font-semibold text-grey-900  text-lg tracking-[0] leading-[normal]">
            {store?.name}
          </div>

          <div className="relative w-fit font-normal text-gray600-secondary-text text-sm tracking-[0] leading-[normal] text-start">
            {store?.categories[0]?.name}
          </div>
        </div>
      </div>
    </div>
  );

}